import React from 'react';
import ContactSection from '../components/ContactSection';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-obsidian pt-20" data-testid="contact-page">
      <ContactSection />
    </div>
  );
};

export default ContactPage;
